import angular from "angular";

import ServiceProviderPayoutModuleRouting from "./service-provider-payout.module.routing";

export default angular
  .module("vt-service-provider-payout", [])
  .config(ServiceProviderPayoutModuleRouting);
